<p-toast position="top-center no-print"></p-toast>
<div class="min-h-screen flex">
  <div id="app-sidebar-8" class=" h-screen hidden lg:block
                                  flex-shrink-0 fixed lg:sticky
                                  left-0 top-0 z-2 select-none
                                  animation-duration-300 animation-ease-in-out
                                  border-right-1
                                  lg:border-right-none surface-border
                                  bg-primary-vertical-revert borderSidebar" (click)="clickInternoSidebar()" [hidden]="!searchBarActive">
    <div class="flex flex-column h-full">
      <div class="flex align-items-center justify-content-center px-5 flex-shrink-0 mt-5" style="height:60px">
        <img [src]="'assets/img/' + baseImagePath + '/logo.png'" alt="Image" height="50">
      </div>
      <div class="overflow-y-auto flex flex-wrap align-items-center justify-content-center w-full h-full mt-5">
        <ul class="list-none p-0 m-0 w-full flex justify-content-center flex-wrap">
          <li class="mb-5 cursor-pointer flex justify-content-center w-full" *ngFor="let menuItem of menuItems; index as i" [routerLink]="menuItem.path">
            <div class="w-full paddingListMenu" (click)="selectMenuItemAt(i, true, true)"
                 [ngClass]="{ 'colorSelectedMenu': menuItem.isActive == true,
                              'hover:colorNotSelectedMenuHover': menuItem.isActive != true }">
              <a pRipple
                 [ngClass]="{ 'text-white': menuItem.isActive == true,
                              'hover:text-white': menuItem.isActive != true}"
                 (click)="selectMenuItemAt(i, true, true)"
                 [pTooltip]="menuItem.title">
                <!--<i [className]="'pi text-lg ' + menuItem.icon"></i>-->
                <img [src]="menuItem.icon + '.svg'" style="width: 1rem" *ngIf="menuItem.isActive != true">
                <img [src]="menuItem.icon + '-white.svg'" style="width: 1rem" *ngIf="menuItem.isActive == true">
                <label class="w-full ml-2 cursor-pointer font-bold text-xl">{{menuItem.title}}</label>
              </a>
            </div>
          </li>
        </ul>

        <ul class="list-none p-0 m-0 w-full flex align-content-end justify-content-center flex-wrap">
          <li class="mb-5 cursor-pointer flex justify-content-center w-full" *ngFor="let menuItem of endMenuItems; index as i" [routerLink]="menuItem.path">
            <div class="w-full paddingListMenu" (click)="selectMenuItemAt(i, false, true)"
                 [ngClass]="{ 'colorSelectedMenu': menuItem.isActive == true,
                              'hover:colorNotSelectedMenuHover': menuItem.isActive != true }">
              <a pRipple
                 [ngClass]="{ 'text-white': menuItem.isActive == true,
                              'hover:text-white': menuItem.isActive != true}"
                 (click)="selectMenuItemAt(i, false, true)"
                 [pTooltip]="menuItem.title">
                <img [src]="menuItem.icon + '.svg'" style="width: 1rem" *ngIf="menuItem.isActive != true">
                <img [src]="menuItem.icon + '-white.svg'" style="width: 1rem" *ngIf="menuItem.isActive == true">
                <label class="w-full ml-2 cursor-pointer font-bold text-xl">{{menuItem.title}}</label>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="min-h-screen flex flex-column relative flex-auto">
    <div class="flex justify-content-between align-items-center px-5 relative lg:static" style="height:60px">
      <div class="flex">
        <a pRipple class="cursor-pointer block lg:hidden text-gray-300 mr-3" pStyleClass="#app-sidebar-8" enterClass="hidden"
           [enterActiveClass]="'fadeinleft'" [leaveClass]="'hidden'" [leaveActiveClass]="'fadeoutleft'"  [hideOnOutsideClick]="true" (click)="openMobileSidebar()">
          <i class="pi pi-bars text-4xl"></i>
        </a>
      </div>
<!--  barra di ricerca
      <div class="col-4">
        <span class="p-input-icon-left w-full">
          <i class="pi pi-search"></i>
          <input id="name"
                 name="name"
                 type="text"
                 pInputText
                 class="w-full">
        </span>
      </div>
-->
      <p-overlayPanel #op>
        <ng-template pTemplate>
          <div class="flex flex-wrap">
            <button pButton pRipple type="button" label="Impostazioni" class="p-button-sm p-button-outlined w-full m-1"
                    (click)="selectSettings()"></button>
            <button pButton pRipple type="button" label="Logout" class="p-button-sm p-button-outlined p-button-danger w-full m-1"
                    (click)="onClickLogout()"></button>
          </div>
        </ng-template>
      </p-overlayPanel>
      <div class="col flex justify-content-end">
        <label *ngIf="profileSex == 'M'" class="mt-2 mr-5">Benvenuto, <label class="font-bold">{{nomeUtente}}</label></label>
        <label *ngIf="profileSex == 'F'" class="mt-2 mr-5">Benvenuta, <label class="font-bold">{{nomeUtente}}</label></label>
        <p-avatar shape="circle"  class="cursor-pointer" (click)="op.toggle($event)">
          <img [src]="profileImageUrl">
        </p-avatar>
      </div>
    </div>
    <div class="flex flex-column flex-auto">
      <div class="surface-section flex-auto">
        <router-outlet></router-outlet>
        <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
      </div>
    </div>
  </div>
</div>
